import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-transcarrier-service-active',
  templateUrl: './transcarrier-service-active.component.html',
  styleUrls: ['./transcarrier-service-active.component.css']
})
export class TranscarrierServiceActiveComponent implements OnInit {
    transcarrierServiceActiveKeyno;

    deliveryMethodNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.transcarrierServiceActiveKeyno = this.stateService.getStateParams()['transcarrier_service_active_keyno'];
        this.deliveryMethodNo = this.stateService.getStateParams()['deliverymethod_no'];
    }

    private async loadEdit() {
        if (!!this.transcarrierServiceActiveKeyno && !!this.deliveryMethodNo) {
            this.edit = (await this.datatask.Post(2657, {
                transcarrier_service_active_keyno: this.transcarrierServiceActiveKeyno,
                deliverymethod_no: this.deliveryMethodNo
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2658, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    transcarrier_service_active_keyno: number;
    transcarrier_name: string;
    transcarrier_product_name: string;
    transcarrier_service_name: string;
    transcarrier_service_isactive: number;
    deliverymethod_no: number;
    transcarrier_keyno: number;
    transcarrier_product_keyno: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transcarrierServiceActive', {
//        templateUrl: 'views/components/views/transcarrierServiceActive/transcarrierServiceActive.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'transcarrierServiceActiveService', 'translateService', function ($stateParams, stateService, modalService, transcarrierServiceActiveService, translateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transcarrierServiceActiveKeyno = $stateParams.transcarrier_service_active_keyno;
//            let deliveryMethodNo = $stateParams.deliverymethod_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await transcarrierServiceActiveService.getEdit({
//                    transcarrier_service_active_keyno: transcarrierServiceActiveKeyno,
//                    deliverymethod_no: deliveryMethodNo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transcarrierServiceActiveService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
